// Hiabaya quick add: "Complete the look" rows open a blurred-backdrop quick view
// (markup from <product url>?view=quick) and add to the bag without leaving the page.
import { CartLinesUpdateEvent } from '@shopify/events';

const CSS = `
html.hb-qa-lock { overflow: hidden; }
.hb-qa { border: 0; padding: 0; margin: auto; width: min(820px, calc(100vw - 32px)); max-height: min(640px, calc(100dvh - 48px)); border-radius: 10px; background: #fff; color: #202020; overflow: hidden; box-shadow: 0 20px 60px rgb(0 0 0 / .18); }
.hb-qa::backdrop { background: rgb(32 32 32 / .28); -webkit-backdrop-filter: blur(8px); backdrop-filter: blur(8px); }
.hb-qa[open] { display: flex; flex-direction: column; animation: hb-qa-in .22s ease-out; }
@keyframes hb-qa-in { from { opacity: 0; transform: translateY(16px); } }
.hb-qa__close { position: absolute; top: 10px; right: 10px; z-index: 2; width: 36px; height: 36px; border-radius: 50%; border: 0; background: rgb(255 255 255 / .92); color: #202020; font-size: 22px; line-height: 1; cursor: pointer; display: grid; place-items: center; box-shadow: 0 1px 4px rgb(0 0 0 / .12); }
.hb-qa__body { overflow-y: auto; overscroll-behavior: contain; min-height: 200px; }
.hb-qa__loading { display: grid; place-items: center; min-height: 320px; font-size: 14px; color: #6A655E; }
.hb-qv { display: grid; grid-template-columns: 46% 1fr; }
.hb-qv__media { display: flex; overflow-x: auto; scroll-snap-type: x mandatory; scrollbar-width: none; background: #F4F2EE; align-self: start; position: sticky; top: 0; }
.hb-qv__media::-webkit-scrollbar { display: none; }
.hb-qv__media img { flex: 0 0 100%; width: 100%; height: auto; scroll-snap-align: start; display: block; }
.hb-qv__info { padding: 28px 28px 24px; display: flex; flex-direction: column; gap: 14px; }
.hb-qv__title { margin: 0; padding-right: 32px; font-family: var(--font-body--family); font-size: 1.125rem; font-weight: 500; line-height: 1.3; letter-spacing: 0; }
.hb-qv__price { display: flex; gap: 8px; align-items: baseline; font-size: 1.125rem; font-weight: 700; color: #C8102E; }
.hb-qv__price s { font-size: .9375rem; font-weight: 400; color: rgb(32 32 32 / .5); }
.hb-qv__opt { border: 0; margin: 0; padding: 0; min-width: 0; }
.hb-qv__opt legend { font-size: 14px; margin-bottom: 8px; padding: 0; }
.hb-qv__vals { display: flex; flex-wrap: wrap; gap: 6px; }
.hb-qv__vals button { min-width: 52px; height: 44px; padding: 0 12px; border: 1px solid #D9D4CC; border-radius: 4px; background: #fff; color: #202020; font: inherit; font-size: 14px; cursor: pointer; }
.hb-qv__vals button:hover { border-color: #6A655E; }
.hb-qv__vals button.is-on { background: #202020; border-color: #202020; color: #fff; }
.hb-qv__vals button.is-out { color: rgb(32 32 32 / .4); text-decoration: line-through; background: #F7F5F2; }
.hb-qv__guide { align-self: flex-start; font-size: 13px; color: #202020; text-decoration: underline; }
.hb-qv__add { height: 52px; border: 0; border-radius: 6px; background: #202020; color: #fff; font: inherit; font-size: 15px; font-weight: 500; cursor: pointer; }
.hb-qv__add:disabled { background: #BDB8B1; cursor: not-allowed; }
.hb-qv__add.is-done { background: #4B5A40; }
.hb-qv__msg { margin: -6px 0 0; font-size: 13px; min-height: 0; }
.hb-qv__msg:empty { display: none; }
.hb-qv__msg.is-err { color: #C8102E; }
.hb-qv__desc { font-size: 13px; line-height: 1.55; color: #45413C; border-top: 1px solid #E3DED6; padding-top: 14px; }
.hb-qv__desc p { margin: 0 0 8px; } .hb-qv__desc ul { margin: 0; padding-left: 18px; } .hb-qv__desc a { color: inherit; }
.hb-qv__fit { font-size: 13px; line-height: 1.5; color: #45413C; } .hb-qv__fit b { display: block; margin-bottom: 2px; color: #202020; } .hb-qv__fit p { margin: 0 0 4px; }
.hb-qv__more { font-size: 13px; color: #202020; text-decoration: underline; }
@media screen and (max-width: 749px) {
  .hb-qa { width: 100vw; max-width: 100vw; max-height: 92dvh; margin: auto 0 0; border-radius: 14px 14px 0 0; }
  .hb-qa[open] { animation: hb-qa-up .26s ease-out; }
  @keyframes hb-qa-up { from { transform: translateY(40px); opacity: .4; } }
  .hb-qv { grid-template-columns: 1fr; }
  .hb-qv__media { position: static; }
  .hb-qv__media img { flex: 0 0 auto; width: auto; height: min(50dvh, 440px); object-fit: cover; }
  .hb-qv__info { padding: 16px 16px calc(20px + env(safe-area-inset-bottom)); gap: 12px; }
  .hb-qv__add { position: sticky; bottom: calc(8px + env(safe-area-inset-bottom)); z-index: 1; box-shadow: 0 6px 16px rgb(0 0 0 / .12); }
}
`;

const style = document.createElement('style');
style.textContent = CSS;
document.head.append(style);

let dialog;
let lastTrigger;
const cache = new Map();

function getDialog() {
  if (dialog) return dialog;
  dialog = document.createElement('dialog');
  dialog.className = 'hb-qa';
  dialog.setAttribute('aria-label', 'Quick view');
  dialog.innerHTML = '<button type="button" class="hb-qa__close" aria-label="Close">&times;</button><div class="hb-qa__body"></div>';
  dialog.querySelector('.hb-qa__close').addEventListener('click', () => dialog.close());
  // Click on the blurred backdrop closes.
  dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('hb-qa-lock');
    lastTrigger?.focus({ preventScroll: true });
  });
  document.body.append(dialog);
  return dialog;
}

async function loadView(url) {
  if (!cache.has(url)) {
    const u = new URL(url, location.origin);
    u.searchParams.set('view', 'quick');
    cache.set(url, fetch(u, { credentials: 'same-origin' }).then((r) => {
      if (!r.ok) throw new Error(String(r.status));
      return r.text();
    }));
  }
  return cache.get(url).catch((e) => { cache.delete(url); throw e; });
}

async function openQuickView(url, trigger) {
  lastTrigger = trigger;
  const dlg = getDialog();
  const body = dlg.querySelector('.hb-qa__body');
  body.innerHTML = '<div class="hb-qa__loading">…</div>';
  body.scrollTop = 0;
  document.documentElement.classList.add('hb-qa-lock');
  if (!dlg.open) dlg.showModal();
  try {
    const html = await loadView(url);
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const view = doc.querySelector('.hb-qv');
    if (!view) throw new Error('no view');
    body.replaceChildren(document.importNode(view, true));
    wireView(body.querySelector('.hb-qv'), trigger);
  } catch (e) {
    location.href = url; // fall back to the full product page
  }
}

function wireView(view, trigger) {
  const variants = JSON.parse(view.querySelector('[data-variants]').textContent);
  const addBtn = view.querySelector('[data-hb-qv-add]');
  const msg = view.querySelector('.hb-qv__msg');
  const price = view.querySelector('[data-price]');
  const compare = view.querySelector('[data-compare]');
  const sets = [...view.querySelectorAll('.hb-qv__opt')];
  const selected = sets.map((fs) => fs.querySelector('[data-fixed]')?.value ?? null);

  // Pre-select when only one value is purchasable (e.g. one-size items).
  sets.forEach((fs, i) => {
    const live = [...fs.querySelectorAll('button:not(.is-out)')];
    if (selected[i] === null && live.length === 1) { selected[i] = live[0].dataset.value; live[0].classList.add('is-on'); }
  });

  const current = () => (sets.length === 0 ? variants[0] : variants.find((v) => v.options.every((o, i) => o === selected[i])));

  function refresh() {
    const v = current();
    msg.textContent = ''; msg.classList.remove('is-err');
    addBtn.classList.remove('is-done');
    if (!v) { addBtn.disabled = true; addBtn.textContent = view.dataset.pick; return; }
    price.textContent = v.price;
    compare.hidden = !v.compare; if (v.compare) compare.textContent = v.compare;
    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? view.dataset.add : view.dataset.out;
  }

  sets.forEach((fs, i) => fs.querySelectorAll('button').forEach((b) => b.addEventListener('click', () => {
    fs.querySelectorAll('button').forEach((x) => x.classList.toggle('is-on', x === b));
    selected[i] = b.dataset.value;
    refresh();
  })));
  if (sets.length === 0 || selected.every((s) => s !== null)) refresh();

  addBtn.addEventListener('click', async () => {
    const v = current();
    if (!v || !v.available) return;
    addBtn.disabled = true;
    const res = await addToBag(v.id, addBtn);
    if (res.ok) {
      addBtn.classList.add('is-done');
      addBtn.textContent = '✓ ' + view.dataset.added;
      markRowAdded(trigger);
      setTimeout(() => dialog?.open && dialog.close(), 900);
    } else {
      addBtn.disabled = false;
      msg.textContent = res.message; msg.classList.add('is-err');
    }
  });
}

async function addToBag(variantId, source) {
  const root = window.Shopify?.routes?.root || '/';
  const sectionIds = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
  const deferred = CartLinesUpdateEvent.createPromise();
  // action 'update' refreshes the bag icon + drawer contents without auto-opening the drawer.
  (source || document).dispatchEvent(new CartLinesUpdateEvent({
    action: 'update',
    context: 'product',
    lines: [{ merchandiseId: String(variantId), quantity: 1 }],
    promise: deferred.promise,
  }));
  try {
    const r = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds.join(',') }),
    });
    const data = await r.json();
    const cart = await fetch(root + 'cart.js').then((x) => x.json());
    const failed = Boolean(data.status);
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'hb-quick-add', sourceId: 'hb-quick-add', itemCount: failed ? 0 : 1, sections: data.sections, didError: failed },
    });
    if (failed) return { ok: false, message: data.description || data.message || 'Could not add' };
    return { ok: true };
  } catch (e) {
    deferred.reject(e);
    return { ok: false, message: 'Network error — please try again' };
  }
}

function markRowAdded(trigger) {
  const row = trigger?.closest('.hb-bundle__row');
  const btn = row?.querySelector('.hb-bundle__act');
  if (btn) { btn.classList.add('is-done'); btn.textContent = '✓ ' + (btn.dataset.done || 'Added'); }
}

document.addEventListener('click', async (e) => {
  const open = e.target.closest('[data-hb-qv]');
  if (open) {
    if (e.metaKey || e.ctrlKey || e.shiftKey) return; // let new-tab clicks through
    e.preventDefault();
    openQuickView(open.dataset.hbQv || open.getAttribute('href'), open);
    return;
  }
  const quick = e.target.closest('[data-hb-add]');
  if (quick && !quick.classList.contains('is-done')) {
    e.preventDefault();
    quick.disabled = true;
    const res = await addToBag(quick.dataset.hbAdd, quick);
    quick.disabled = false;
    if (res.ok) markRowAdded(quick);
    else { quick.title = res.message; quick.textContent = '!'; }
  }
});
